// MODULES //
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";

// SERVICES //
import { StoredataService } from "../services/storedata.service";
import { ApiservicesService } from "./apiservices.service";
import { FingerprintService } from "./fingerprint.service";

// OTHERS //
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  authenticationState = new BehaviorSubject(null); //AVOID ANY PAGE TO LOAD INITIALLY
  constructor(
    private storedataService: StoredataService,
    private apiservices: ApiservicesService,
    private fingerprintService: FingerprintService,
    private storage: Storage,
    private router: Router
  ) {
    // GET USER DATA STORED IN DEVICE
    this.checkuser();
  }

  /**
   * LOGOUT
   * @returns void
   */
  logout() {
    this.authenticationState.next(false);
  }

  /**
   * FETCH LATEST DATA FROM BACKEND
   * @param contact - The contact number of the user
   * @returns A promise that resolves to the latest data
   */
  async fetchLatestData(contact: string): Promise<any> {
    try {
      // GET DEVICE FINGERPRINT
      const device_fingerprint = await this.fingerprintService.getFingerprint();

      // FETCH LATEST DATA FROM BACKEND
      return new Promise((resolve, reject) => {
        this.apiservices.dologin({ contact, device_fingerprint }).subscribe(
          (data: any) => {
            // STORE DATA IN LOCAL STORAGE
            if (data) {
              this.storedataService.nutritionistdata = data;
              this.storedataService.setNutritionist(data);
              resolve(data);
            } else {
              reject("Failed to fetch latest data");
            }
          },
          (error) => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error("Error fetching latest data:", error);
      throw error;
    }
  }

  /**
   * CHECK USER
   * @returns void
   */
  async checkuser() {
    try {
      const contact = localStorage.getItem("nutritionistcontact");
      if (contact) {
        try {
          // First fetch latest data from backend
          const latestData = await this.fetchLatestData(contact);
          // Then check if user is active
          if (latestData && latestData.isactive == 1) {
            this.authenticationState.next(true);
          } else {
            this.logout();
          }
        } catch (error) {
          console.error("Error fetching latest data:", error);
          // If fetch fails, check stored data as fallback
          const storedData = await this.storedataService.returnlocaldata();
          // CHECK IF USER IS ACTIVE
          if (storedData && storedData.isactive == 1) {
            this.authenticationState.next(true);
          } else {
            this.logout();
          }
        }
      } else {
        this.logout();
      }
    } catch (error) {
      console.error("Error in checkuser:", error);
      this.logout();
    }
  }
}
